import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  "aria-label": "Setup progress",
  class: "flex h-full flex-col bg-white"
}
const _hoisted_2 = { class: "px-6 pb-4 pt-6" }
const _hoisted_3 = { class: "flex items-baseline justify-between" }
const _hoisted_4 = { class: "m-0 text-[15px] font-semibold text-gray-900" }
const _hoisted_5 = {
  key: 0,
  "data-rail-count": "",
  class: "text-[13px] text-gray-500"
}
const _hoisted_6 = ["data-segment"]
const _hoisted_7 = { class: "m-0 flex flex-grow list-none flex-col gap-0.5 overflow-y-auto px-3 py-1" }
const _hoisted_8 = {
  key: 0,
  class: "flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full bg-[#dcfce7] text-[#15803d]"
}
const _hoisted_9 = {
  key: 1,
  class: "flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full bg-gray-900 text-xs font-semibold text-white"
}
const _hoisted_10 = {
  key: 2,
  class: "m-px flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border border-dashed border-[#3b82f6] text-xs text-[#1d4ed8]"
}
const _hoisted_11 = {
  key: 3,
  class: "m-px flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border border-[#cbd0d8] text-xs text-gray-500"
}
const _hoisted_12 = { class: "flex min-w-0 flex-grow flex-col gap-0.5" }
const _hoisted_13 = { "data-label": "" }
const _hoisted_14 = {
  key: 0,
  class: "rounded bg-[#dbeafe] px-1.5 py-px text-[11px] font-semibold text-[#1d4ed8]"
}
const _hoisted_15 = {
  key: 1,
  class: "rounded bg-[#f1f5f9] px-1.5 py-px text-[11px] font-medium text-[#475569]"
}
const _hoisted_16 = {
  key: 0,
  "data-foot": "",
  class: "border-t border-[#eef0f3] px-6 py-4"
}

import { computed } from 'vue'


export default {
  __name: 'WizardRail',
  props: {
  rows: { type: Array, default: () => [] },
  title: { type: String, default: 'Setup' },
  showProgress: { type: Boolean, default: true }
},
  emits: ['jump'],
  setup(__props) {

const SEGMENT = { done: 'bg-[#16a34a]', current: 'bg-gray-900', added: 'bg-[#bfdbfe]', upcoming: 'bg-gray-200' }
const ROW_BG = { done: '', current: 'bg-[#f1f3f6]', added: 'bg-[#f5f9ff]', upcoming: '' }
const LABEL = {
  done: 'font-medium text-gray-900',
  current: 'font-semibold text-gray-900',
  added: 'font-medium text-gray-900',
  upcoming: 'font-medium text-gray-600'
}
const SUMMARY = { done: 'text-gray-700', current: 'text-gray-700', added: 'text-[#1e40af]', upcoming: 'text-gray-500' }

const props = __props


const doneCount = computed(() => props.rows.filter(row => row.state === 'done').length)

const lowerFirst = text => text.charAt(0).toLowerCase() + text.slice(1)

const summary = row => {
  if (row.state === 'added') return `Added because you ticked ${row.addedBecause}`
  if (row.state === 'upcoming' && row.isDefault) return `Default: ${lowerFirst(row.value)}`
  return row.value
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1),
        (__props.showProgress)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(doneCount.value) + " of " + _toDisplayString(__props.rows.length) + " done ", 1))
          : _createCommentVNode("", true)
      ]),
      (__props.showProgress)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "mt-3 grid gap-[3px]",
            style: _normalizeStyle({ gridTemplateColumns: `repeat(${__props.rows.length}, minmax(0, 1fr))` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row) => {
              return (_openBlock(), _createElementBlock("span", {
                key: row.key,
                "data-segment": row.state,
                class: _normalizeClass(["h-1 rounded-sm", SEGMENT[row.state]])
              }, null, 10, _hoisted_6))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ol", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: row.key
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(row.to ? 'router-link' : 'button'), _mergeProps({ ref_for: true }, row.to ? { to: row.to } : { type: 'button', disabled: !row.jumpable }, {
            "data-row": "",
            "data-done": String(row.state === 'done'),
            "data-state": row.state,
            "aria-current": row.state === 'current' ? 'step' : undefined,
            class: ["flex w-full gap-3 rounded-lg px-3 py-2.5 text-left no-underline transition focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-gray-900 disabled:cursor-default", [
            ROW_BG[row.state],
            (row.to || (row.jumpable && row.state !== 'current')) && 'hover:bg-gray-50',
            row.indent && 'pl-8'
          ]],
            onClick: $event => (!row.to && row.jumpable && _ctx.$emit('jump', row.key))
          }), {
            default: _withCtx(() => [
              (row.state === 'done')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("svg", {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "3.5",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", {
                        d: "M5 12l5 5L20 7",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1)
                  ]))]))
                : (row.state === 'current')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(index + 1), 1))
                  : (row.state === 'added')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(index + 1), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(index + 1), 1)),
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("span", {
                  class: _normalizeClass(["flex flex-wrap items-center gap-1.5 text-sm", LABEL[row.state]])
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(row.label), 1),
                  (row.state === 'added')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, " New step "))
                    : (row.fromIncludes)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " from Includes "))
                      : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("span", {
                  "data-value": "",
                  class: _normalizeClass(["text-[13px] leading-[1.45]", SUMMARY[row.state]])
                }, _toDisplayString(summary(row)), 3)
              ])
            ]),
            _: 2
          }, 1040, ["data-done", "data-state", "aria-current", "class", "onClick"]))
        ]))
      }), 128))
    ]),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}